import React from "react";
import PRODUCT_ICONS from "../../constants/product-icons";
import { isTablet } from "react-device-detect";
import { Row, Image } from "react-bootstrap";
import "./styles.scss";

export default function AttributeIconIndex(props) {
  const { isMobile } = props;
  return (
    <div className="align-self-center attribute-icon-index">
      <Row className="justify-content-center">
        {["Dietician Choice", "Luxury Grade", "Popular Choice"].map(
          (element) => (
            <Row
              className={`${isMobile ? "pl-1 pr-1 " : "ml-3"}`}
              key={element}
            >
              <Image
                src={PRODUCT_ICONS[element]}
                className="attribute-icon align-self-center"
                style={isTablet ? { width: "3vw", height: "3vw" } : {}}
              />
              <span className={`${isMobile ? "ml-1 " : "ml-2"}`}>
                - {element}
              </span>
            </Row>
          )
        )}
      </Row>
    </div>
  );
}
